/** 外链判定：jumpType / showType === 3 且带 linkUrl（对齐 PC 的字段判断），仅外链加 nofollow、新窗口打开 */
export function isExternalLink(item: any): boolean {
	return !!(item && (Number(item.jumpType) === 3 || Number(item.showType) === 3) && item.linkUrl);
}

export default isExternalLink;
